module.exports = __webpack_public_path__ + "img/_logo-visa.a526cb7b.svg";